module.exports = __webpack_public_path__ + "images/img-2SG7ZSd.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/postback-info/ru/1.png
// module id = 2326
// module chunks = 0